// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"m0-z","subtitle":"n0-z","wrapper":"o0-z","leftArrow":"p0-z","rightArrow":"q0-z"};